import { useWidth } from "@/shared/hooks/use-width.hook";
import { Grid, styled } from "@mui/material";
import { useEffect } from "react";
import { useRealEstateDetailContext } from "../../context/realestate-details.context";
import LabelValueText from "@/src-refactor/modules/shared/components/typography/label-value-text/LabelValueText";
import MxButton from "@rf-l1/buttons/MxButton";
import MapIcon from "@/assets/icons/google_maps.svg?react";
import MxFormSubTitle from "@rf-l1/page/form/MxFormSubTitle";

const LocationDescription = () => {
  const width = useWidth();
  const isMobile = ["xs", "sm"].includes(width);

  const linkMap = (latitude: number, longitude: number) => {
    const url = `https://www.google.com/maps?q=${latitude},${longitude}`;
    window.open(url, "_blank");
  };

  const {
    PROPERTY_DETAIL: { principalData, project }
  } = useRealEstateDetailContext();

  useEffect(() => {}, []);

  return (
    <Container>
      <Grid item xs={"auto"} marginTop={isMobile ? 1.8 : 1}>
        <MxFormSubTitle label="Ubicación" />
      </Grid>

      <Grid
        container
        spacing={isMobile ? 0.6 : 2}
        alignItems="center"
        flexWrap="wrap"
        padding="0.1rem 0rem 0.5rem 0rem"
      >
        <Grid item xs={12} sm="auto">
          <LabelValueText
            label="Ciudad"
            value={principalData.general_information.city}
          />
        </Grid>

        <Grid item xs={12} sm="auto">
          <LabelValueText
            label="Sector"
            value={principalData.general_information.sector}
          />
        </Grid>

        <Grid item xs={12} sm="auto">
          <LabelValueText label="Dirección" value={principalData.address} />
        </Grid>

        <Grid item xs={12} sm="auto">
          <MxButton
            onClick={() => linkMap(principalData.latitude, principalData.longitude)}
            size={"sm"}
            endIcon={<MapIcon width={16} height={16} />}
          >
            Ver en mapa
          </MxButton>
        </Grid>
      </Grid>
    </Container>
  );
};

export default LocationDescription;

const Container = styled("div")({
  marginTop: "10px",
  marginBottom: "12px"
});
